import { IPlanification, ISubscription } from '@sdk/contracts';
import { dateProvider } from '@utils';

export const getPlanificationEvents = (data?: IPlanification) => {
  if (!data || !data.items.length || !data.active) return [];

  const eventsMap = new Map<
    string,
    {
      id: string;
      title: string;
      date: Date;
      allDay: boolean;
      color: string;
      subscription: ISubscription;
      activityId: string;
    }
  >();

  data.items
    .map(item => {
      const subscription = data.subscriptions.find(s => s._id === item.subscription);
      const section = subscription?.course.sections.find(s =>
        s.activities.find(a => a._id.toString() === item.activity)
      );
      const activity = section?.activities.find(a => a._id.toString() === item.activity);

      return {
        ...item,
        activity,
        section,
        subscription
      };
    })
    .forEach(item => {
      const date = dateProvider.format(item.dueDate, 'yyyy-MM-dd');
      const title =
        data.subscriptions.length > 1 ? item.subscription!.course.name : item.section!.name;
      const key = `${date}-${title}`;
      if (!eventsMap.has(key) && item.activity) {
        eventsMap.set(key, {
          id: key,
          title,
          date: item.dueDate,
          allDay: true,
          color: 'transparent',
          subscription: item.subscription!,
          activityId: item.activity!._id
        });
      }
    });

  return Array.from(eventsMap.values()).flat();
};
